module.exports = __webpack_public_path__ + "d9aa55c463e2dc69eba66fc5a15a62f9.svg";